import styled from 'styled-components'
import { routes } from '@shared/constants/routes'
import { spacing } from '@/features/shared/theme/tokens'
import { Body, Display } from '@shipt/design-system-typography'
import { ButtonLink } from '@/features/shared/elements/Link/Buttons'
import { Image } from '@/features/shared/elements/Image/NextImage'
import { screenSizes } from '@shipt/design-system-themes'
import { objectStorageUrl } from '@/features/shared/utils/objectStorageUrl'
import { Column } from '@shipt/design-system-layouts'
import { type PlaceholderData } from '@/features/cms/components/CMS/types'
import { GridLayoutContainer } from '@/features/shared/styles/layout'
import { getCMSWrapperProps } from '@/features/cms/components/CMS/utils/getCMSWrapperProps'
import { trackElementClicked } from '@/features/shared/analytics/element'
import { getTargetCircleQueryParams } from '@/features/shared/components/Headers/Circle360Header/utils'
import { useSearchParams } from 'next/navigation'
import { C360Logo } from '@/features/shared/components/C360Logo'

export const Circle360ActivationHero = ({
  content_type_id,
  id,
}: Pick<PlaceholderData, 'content_type_id' | 'id'>) => {
  const searchParams = useSearchParams()
  const params = getTargetCircleQueryParams(searchParams)
  return (
    <GridLayoutContainer {...getCMSWrapperProps({ content_type_id, id })}>
      <Container>
        <Content>
          <Column spacing="xxl">
            <Display size="md">Unlimited same-day delivery from retailers near you</Display>
            <Body size="xl" variant="secondary">
              Get the most out of your Target Circle 360&#8482; membership with Shipt.
            </Body>
            <Circle360Button
              href={`${routes.LOGIN.url}${params}`}
              aria-label="Sign in with Target Circle 360"
              onClick={() =>
                trackElementClicked({
                  type: 'button',
                  content: 'Sign in on banner',
                  display_sublocation: 'banner',
                })
              }
              nativeLink
              trailingIcon={() => <C360Logo width={102} height={18} inverse />}
            >
              Sign in with
            </Circle360Button>
          </Column>
        </Content>
        <ImageWrapper>
          <Image
            src={objectStorageUrl('360herofinal.png')}
            alt=""
            height={387}
            width={611}
            style={{ objectFit: 'contain' }}
          />
        </ImageWrapper>
      </Container>
    </GridLayoutContainer>
  )
}

const Container = styled.section`
  display: flex;
  flex-direction: column;
  margin: ${spacing('auto')};
  gap: ${spacing('xxl')};
  border-radius: 8px;
  align-items: center;

  @media ${screenSizes.tablet} {
    flex-direction: row;
  }

  @media ${screenSizes.lgDesktop} {
    gap: 3.5rem;
  }
`

const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const Circle360Button = styled(ButtonLink)`
  white-space: nowrap;
  max-width: 16rem;
`

const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  @media ${screenSizes.max_mobile} {
    display: none;
  }
`
